import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _createSuper from "@babel/runtime/helpers/createSuper";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React from 'react';
import { layout } from '../styles';
import { TooltipBuilder } from '../Tooltip/TooltipBuilder';
import { StyledTooltip } from '../Tooltip/TooltipBuilder.styled';
import { StyledButton } from './GenericButton.styled';
export var ButtonWrapper = /*#__PURE__*/function (_React$Component) {
  _inherits(ButtonWrapper, _React$Component);
  var _super = _createSuper(ButtonWrapper);
  function ButtonWrapper() {
    var _this;
    _classCallCheck(this, ButtonWrapper);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "state", {
      showTooltip: false
    });
    _defineProperty(_assertThisInitialized(_this), "longPressTimer", void 0);
    _defineProperty(_assertThisInitialized(_this), "shouldShowTooltip", true);
    _defineProperty(_assertThisInitialized(_this), "isLongPress", false);
    _defineProperty(_assertThisInitialized(_this), "toolTipTimeout", void 0);
    _defineProperty(_assertThisInitialized(_this), "onClick", function (e) {
      if (!_this.props.onClick || _this.isLongPress) {
        return;
      }
      _this.props.onClick(e);
      _this.setState({
        showTooltip: false
      });
    });
    _defineProperty(_assertThisInitialized(_this), "onMouseEnter", function (e) {
      _this.toolTipTimeout = setTimeout(function () {
        _this.setState({
          showTooltip: _this.shouldShowTooltip
        });
      }, 1000);
      if (_this.props.onMouseEnter) {
        _this.props.onMouseEnter(e);
      }
    });
    _defineProperty(_assertThisInitialized(_this), "onMouseLeave", function (e) {
      if (_this.toolTipTimeout) {
        clearTimeout(_this.toolTipTimeout);
      }
      _this.shouldShowTooltip = false;
      setTimeout(function () {
        if (!_this.shouldShowTooltip) {
          _this.setState({
            showTooltip: false
          });
          _this.shouldShowTooltip = true;
        }
      }, 50);
      if (_this.props.onMouseLeave) {
        _this.props.onMouseLeave(e);
      }
    });
    _defineProperty(_assertThisInitialized(_this), "onTouchStart", function (e) {
      _this.shouldShowTooltip = false;
      _this.isLongPress = false;
      _this.longPressTimer = setTimeout(function () {
        _this.shouldShowTooltip = true;
        _this.isLongPress = true;
        _this.setState({
          showTooltip: true
        });
      }, 500);
      if (_this.props.onTouchStart) {
        _this.props.onTouchStart(e);
      }
    });
    _defineProperty(_assertThisInitialized(_this), "onTouchEnd", function (e) {
      if (_this.longPressTimer) {
        clearTimeout(_this.longPressTimer);
      }
      if (_this.props.onTouchEnd) {
        _this.props.onTouchEnd(e);
      }
    });
    return _this;
  }
  _createClass(ButtonWrapper, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        children = _this$props.children,
        title = _this$props.title,
        buttonProps = _objectWithoutProperties(_this$props, ["children", "title"]);
      return /*#__PURE__*/React.createElement(TooltipBuilder, {
        tooltipVisible: this.state.showTooltip && !!(title !== null && title !== void 0 && title.trim()) && !buttonProps.disabled,
        renderHoverTrigger: function renderHoverTrigger(hoverTriggerProps) {
          return /*#__PURE__*/React.createElement(StyledButton, _extends({
            type: "button",
            ref: hoverTriggerProps.ref,
            "aria-label": title
          }, buttonProps, {
            disabled: buttonProps.disabled,
            onMouseEnter: _this2.onMouseEnter,
            onMouseLeave: _this2.onMouseLeave,
            onTouchStart: _this2.onTouchStart,
            onTouchEnd: _this2.onTouchEnd,
            onClick: _this2.onClick,
            className: "citrix-ui__button ".concat(_this2.props.className || '')
          }), React.Children.map(_this2.props.children, function (child) {
            if (typeof child === 'string') {
              return /*#__PURE__*/React.createElement("span", {
                tabIndex: -1
              }, child);
            }
            return /*#__PURE__*/React.isValidElement(child) && /*#__PURE__*/React.cloneElement(child, {
              tabIndex: -1
            });
          }));
        },
        renderTooltip: function renderTooltip(props, arrowElement) {
          return /*#__PURE__*/React.createElement(StyledTooltip, _extends({}, props, {
            style: _objectSpread(_objectSpread({}, props.style), {}, {
              padding: "".concat(layout.smallSpace, " ").concat(layout.mediumSpace),
              minWidth: '80px',
              textAlign: 'center'
            })
          }), title, arrowElement);
        }
      });
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.toolTipTimeout) {
        clearTimeout(this.toolTipTimeout);
      }
    }
  }]);
  return ButtonWrapper;
}(React.Component);